// Custom TypeScript implementation of Spencer Mortensen's link-xor email obfuscator
// https://spencermortensen.com/articles/email-obfuscation/src/link-xor.js

// Encode: new EmailLinkProcessor([0-255]).encode('email@domain.com')
// Decode: new EmailLinkProcessor([0-255]).decode('[anchor class selector]')

class TextXor {

    private key:number;

    constructor(key:number) {
        this.key = key;
    }

    public encode = (input:string) => {
        let output = '';

        for (let i = 0; i < input.length; ++i) {
            const hexInput = input.charCodeAt(i);
            const hexOutput = hexInput ^ this.key;
    
            output += this.fromHex(hexOutput);
        }
    
        return output;
    }

    public decode = (input:string) => {
        let output = ''; 

        for (let i = 0; i < input.length; i += 2) {
            const hexInput = this.toHex(input, i);
            const hexOutput = hexInput ^ this.key;
    
            output += String.fromCharCode(hexOutput);
        }
    
        return output;
    }

    private fromHex = (hex:number) => {
        let text = hex.toString(16);
        if (hex < 16) {
            text = '0' + text;
        }
        return text;
    }

    private toHex = (text:string, i:number) => {
        const sequence = text.substring(i, i+2);
        return parseInt(sequence, 16);
    }
}

class LinkCoder {
	private coder:TextXor;

    constructor(coder:TextXor) {
        this.coder = coder;
    }

    public encode = (a:HTMLAnchorElement) => {
        this.apply('encode', a);
    }
    
    public decode = (a:HTMLAnchorElement) => {
        this.apply('decode', a);
    }

    private apply = (action:string, a:HTMLAnchorElement) => {
        const input = a.getAttribute('href') as string;
        let output:string = "";

        switch(action) {
            case "encode":
                output = this.coder.encode(input);
                break;

            case "decode":
                output = this.coder.decode(input);
                break;
        }
        
        a.setAttribute("href", "mailto:"+output);
        a.innerText = output;
    }
}

class EmailLinkProcessor {

    private textXor:TextXor;
    private linkCoder:LinkCoder;

    constructor(key:number) {
        if (key < 0 || key > 255) {
            throw new Error("key must be >= 0 and <= 255");
        }
        this.textXor = new TextXor(key);
        this.linkCoder = new LinkCoder(this.textXor);

    }

    public decode = (selector:string) => {
        document.addEventListener('DOMContentLoaded', () => {
            const anchorElements = document.querySelectorAll(selector);
            if (anchorElements.length) {
                anchorElements.forEach((anchorElement) => {
                    if (anchorElement instanceof HTMLAnchorElement) {
                        this.linkCoder.decode(anchorElement);
                    }
                })
            }
        })
    }

    public encode = (email:string) => {
        return this.textXor.encode(email);
    }
}

export default EmailLinkProcessor;